/**
 * Network sanitizers for LogRocket session recording.
 *
 * Requests to and responses from /pii_data carry decrypted FEIN/SSN values
 * (the license wizard POSTs the typed FEIN there; the PII reveal fetches it
 * back), so their bodies are dropped before LogRocket records them.
 */

const PII_DATA_PATH = /\/pii_data(?:[/?#.]|$)/

/**
 * @param {string|undefined} url - absolute or root-relative request URL
 * @returns {boolean} true when the URL targets the /pii_data resource
 */
export function isPiiDataUrl(url) {
  if (typeof url !== "string") return false
  return PII_DATA_PATH.test(url.split("?")[0].split("#")[0])
}

/**
 * Builds the request/response sanitizer pair for LogRocket's `network` option.
 * Returning null from requestSanitizer makes LogRocket drop the request and
 * its response; the response sanitizer also redacts any /pii_data body it is
 * still handed.
 *
 * @returns {{requestSanitizer: Function, responseSanitizer: Function}}
 */
export function createLogRocketSanitizer() {
  const requestSanitizer = (request) => (isPiiDataUrl(request.url) ? null : request)

  const responseSanitizer = (response) => {
    if (isPiiDataUrl(response.url)) response.body = null
    return response
  }

  return { requestSanitizer, responseSanitizer }
}
